import React, { useEffect, useState } from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import SearchIcon from "../../assets/icons/search.svg2";
import FilterIcon from "../../assets/icons/filter.svg2";
import { proxyAPI } from "../proxyAPI";
import ProjectCard from "./ProjectCard";
import BroadcastAvailableProjects from "./BroadcastAvailableProjects";

export default function BroadcastSelectedProjects({
  selected,
  onSelect,
  useUuid = false,
  extraFields,
}: {
  selected: number[] | undefined;
  onSelect: (
    project: { ID: number; UUID: string; Reference: string } | undefined
  ) => void;
  useUuid?: boolean;
  extraFields?: (project: {
    ID: number;
    UUID: string;
    Reference: string;
  }) => React.ReactNode;
}) {
  const [show, setShow] = useState(selected?.length ? false : true);
  const [selectedProjects, setSelectedProjects] = useState<any[]>();
  const [availableProjects, setAvailableProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setdebouncedSearch] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setdebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  // get available projects
  useEffect(() => {
    (async () => {
      let sp;
      if (selected?.length) {
        sp = await proxyAPI({
          prefix: "logic/workflows/api",
          url: `/project-handlers-list?${selected
            .map((id) => `${useUuid ? "uuids" : "ids"}=${id}`)
            .join("&")}`,
        });
      } else {
        setSelectedProjects([]);
      }
      const data = await proxyAPI({
        prefix: "logic/workflows/api",
        url: `/project-handlers?label=${debouncedSearch}&${
          selected
            ? selected
                .map((id) => `${useUuid ? "ignoreUUID" : "ignore"}=${id}`)
                .join("&")
            : ""
        }`,
      });
      if (sp?.length) {
        setSelectedProjects(sp);
      }
      if (data) {
        setAvailableProjects(data.handlers);
      }
    })();
  }, [selected]);

  useEffect(() => {
    (async () => {
      const data = await proxyAPI({
        prefix: "logic/workflows/api",
        url: `/project-handlers?label=${debouncedSearch}&${
          selected
            ? selected
                .map((id) => `${useUuid ? "ignoreUUID" : "ignore"}=${id}`)
                .join("&")
            : ""
        }`,
      });

      if (data) {
        setAvailableProjects(data.handlers);
      }
    })();
  }, [debouncedSearch]);

  return show ? (
    <>
      <div className=" p-3 d-flex justify-content-between mb-3">
        <div className="w-50">
          <div className="fw-bold">
            Select which boomLogic(s) you'd like to connect with:
          </div>
          <div className="text-secondary  ">
            Select the logic project to use. You can pass triggers and input
            arguments to it.
          </div>
        </div>
        {/* <div className="fw-bold">
          <span className="badge bg-icon rounded-pill text-black fs-4 me-3">
            {0}
          </span>
          Project Selected:
        </div> */}
      </div>

      <div>
        <div className="d-flex bg-icon p-3 mb-3 rounded-3">
          <div className="flex-grow-1" />
          <div className="position-relative w-50">
            <input
              className="form-control bg-purple rounded-3 "
              style={{ height: 38, paddingRight: 40 }}
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            <SearchIcon
              width={30}
              className="bg-purple-gradient position-absolute top-50 end-0 translate-middle rounded-3 p-2"
              style={{ marginRight: -10 }}
            />
          </div>
        </div>

        <div className="mb-3">
          <div className="mb-3">Selected Projects</div>
          {selectedProjects?.length ? null : (
            <div className="text-secondary my-3"> No project selected </div>
          )}
          <div className="row g-3">
            {!!selectedProjects?.length &&
              selectedProjects.map((sp: any) => (
                <div className="col-6" key={sp.ID}>
                  <ProjectCard
                    campaign={sp}
                    selected={true}
                    onSelect={onSelect}
                    extraFields={extraFields}
                  />
                </div>
              ))}
          </div>
        </div>

        <div className="mb-3">
          <div className="mb-3">Available Projects</div>
          <div className="row g-3">
            {availableProjects?.length ? (
              availableProjects.map((campaign: any) => (
                <div className="col-6" key={campaign.ID}>
                  <ProjectCard
                    campaign={campaign}
                    selected={false}
                    onSelect={onSelect}
                    extraFields={extraFields}
                  />
                </div>
              ))
            ) : (
              <div className="text-secondary my-3">No projects found</div>
            )}
          </div>
        </div>
      </div>
      {!!selectedProjects?.length && (
        <div className="d-flex justify-content-end mt-2 mb-5">
          <button
            type="button"
            className="btn  btn-colored p-2 px-3 rounded-pill text-white fw-bold text-center"
            onClick={() => {
              setShow(false);
            }}
          >
            Close
          </button>
        </div>
      )}
    </>
  ) : (
    <>
      {!!selectedProjects?.length && (
        <div className="my-3">
          <div className="d-flex justify-content-between align-items-start">
            <div className="fw-bold">Selected projects</div>
            <div>
              <button
                type="button"
                className="btn  btn-colored p-1 px-2 rounded-pill text-white fw-bold text-center"
                onClick={() => {
                  setShow(true);
                }}
              >
                SELECT A PROJECT
              </button>
            </div>
          </div>
          <div className="row">
            {selectedProjects?.length &&
              selectedProjects.map((sp: any) => (
                <div className="col-xl-6" key={sp.ID}>
                  <ProjectCard
                    campaign={sp}
                    selected={true}
                    extraFields={extraFields}
                  />
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
}
